import { Injectable } from "@angular/core";
import { UserService } from "./user.service";
import { HttpHeaders } from "@angular/common/http";

@Injectable({ providedIn: "root" })
export class HttpService {
  constructor(private userService: UserService) {}

  getOptions() {
    return {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${this.userService.getToken()}`,
      }),
    };
  }
}
